
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { generateCharacterSlug } from "@/utils/characterSlug";

export const useCharacterBySlug = (slug: string | undefined) => {
  return useQuery({
    queryKey: ["character-by-slug", slug],
    queryFn: async () => {
      if (!slug) {
        throw new Error("Character slug is required");
      }

      console.log("Fetching character with slug:", slug);

      // Get all published characters and find the one with matching slug
      const { data: characters, error } = await supabase
        .from("characters")
        .select("*")
        .eq("status", "published");

      if (error) {
        console.error("Error fetching characters:", error);
        throw error;
      }

      if (!characters || characters.length === 0) {
        throw new Error("No characters found");
      }

      // Find character by matching stored slug or generated slug
      const character = characters.find(char => {
        const storedSlug = char.slug || generateCharacterSlug(char.name);
        return storedSlug === slug;
      });

      if (!character) {
        throw new Error("Character not found");
      }

      console.log("Found character:", character.name);
      return character;
    },
    enabled: !!slug,
  });
};
